export class InterfaceElementTemplate {
  /*Templates - All were using to fix positions on UI*/
  public static readonly EntityListTemplate = '6df7ed3d-fb18-40e3-a331-a334576c6dd3';
  public static readonly EntityDetailTemplate = '4ecb9955-9166-4da3-b06c-9d1c8f971aa1';
  public static readonly SearchTextBoxTemplate = 'c0051a69-05a1-400c-bc73-43e5182820a3';
  public static readonly SearchTriggerTemplate = '80136f9b-bd9d-47ed-a174-d4495fca4338';
  public static readonly LabelCosyFactoryTemplate = '02072185-9202-4538-ad85-940a541b0944';
  public static readonly LabelViewAreaTemplate = 'dba655b6-2a7b-4e2e-887b-7dd8d47e88f9';
  public static readonly LabelPlaceHolderTemplate = '1cc0319f-ba38-4e33-931f-2913bb1917fc';
  public static readonly MenuTemplate = '08495e5c-cb7e-46eb-b315-4114dfd6cec4';
  
  public static readonly FormActionListViewTemplate = '0165fd32-c089-42f1-9ae8-6ed4a1e35b27';
  public static readonly RecordPerPageTemplate = 'df40fadb-21be-4254-ac63-e025d3f0b470';
  public static readonly ViewsTemplate = '21f094b0-cf44-4363-8f76-a088052f33db';
  public static readonly DataRealmsTemplate = 'cb074fb6-1324-4bcf-b2df-04d445ae2e05';

  public static readonly ListViewRefreshTemplateID = '5d667b9c-4fe9-4a0e-85b2-2f54a3130867';
  public static readonly EntityViewRefreshTemplateID = '366a45dc-980c-4f53-a11e-95791e4cdcb8';

  public static readonly LanguageDETriggerLVTemplate = '23d85163-dc21-46d8-afa7-eb4d783bdda2';
  public static readonly LanguageENTriggerLVTemplate = '3379634b-c9e7-49b6-8cdd-c733f09734bd';

  public static readonly LanguageDETriggerEVTemplate = '87479c29-fea5-451c-8967-98e6aad6aba3';
  public static readonly LanguageENTriggerEVTemplate = '8ab6302a-dca9-4436-afab-b60f6a7e7a9b';

  public static readonly LanguageDETriggerWizardTemplate = 'da0f4041-ae28-4f14-bac7-aaea77ced4c3';
  public static readonly LanguageENTriggerWizardTemplate = '64fd64fb-928f-4bc4-9fa7-e7dc51ec9668';

}
